// 错误标题与错误码文案集中维护；cloud 模式使用远端断线提示，kiosk 模式保留机器端原文案。
const DEFAULT_APP_ERROR_TITLE = "Error Detected!<br/>A serious issue has occurred. Please restart the Hakkobako fermentation chamber. <br/>If the problem persists, contact your sales representative or distributor for assistance.";
const CLOUD_DISCONNECTED_ERROR_TITLE = "communication disconnected, please refresh the page to reconnect";

export const APP_ERROR_TITLE = (process.env.REACT_APP_RUNTIME_MODE || "kiosk").toLowerCase() === "cloud"
  ? CLOUD_DISCONNECTED_ERROR_TITLE
  : DEFAULT_APP_ERROR_TITLE;

export const APP_ERROR_CODE_MESSAGES: Record<string, string> = {
  E1a: "E1a<br/>" +
    "Ambient temperature is too high.<br/>" +
    "1) Allow sufficient machine space for hot air to ventilate out. <br/>" +
    "2) Cool down the ambient room temperature.<br/>" +
    "Restart the machine.  If error persists, contact your service provider or an authorized HakkoBako service company.",
  E1b: "E1b<br/>" +
    "Chamber is overheated. <br/>" +
    "Turn off the machine, open the door and let it cool down to room temperature before turning back on.<br/>" +
    "If error persists, contact your service provider or an authorized HakkoBako service company.",
  E2a: "E2a<br/>" +
    "Ambient temperature is too low.<br/>" +
    "1) Warm up the ambient temperature.<br/>" +
    "If error persists, contact your service provider or an authorized HakkoBako service company.",
  E2b: "E2b<br/>" +
    "Chamber is too cold. <br/>" +
    "Turn off the machine, open the door and let it warm up to room temperature before turning back on.<br/>" +
    "If error persists, contact your service provider or an authorized HakkoBako service company.",
  E3a: "E3a<br/>" +
    "IO related (Hardware) error.<br/>" +
    "Restart the machine. If error persists, contact your service provider or an authorized<br/>" +
    "HakkoBako service company.",
  E3b: "E3b<br/>" +
    "LED related (Hardware) error.<br/>" +
    "Restart the machine. If error persists, contact your service provider or an authorized<br/>" +
    "HakkoBako service company.",
  E3c: "E3c<br/>" +
    "Thermal sensor (Hardware) error. <br/>" +
    "Restart the machine. If error persists, contact your service provider or an authorized<br/>" +
    "HakkoBako service company.",
  E4: "E4<br/>" +
    "Operating system error. <br/>" +
    "Restart the machine. If error persists, contact your service provider or an authorized<br/>" +
    "HakkoBako service company.",
};
